import { t as l } from "./tippy.esm-DLHdsnfG.js";
const c = (t) => {
  let e = !1;
  if (t.childNodes.length === 1 && t.childNodes[0].nodeType === Node.TEXT_NODE) {
    const a = t.scrollWidth > t.offsetWidth;
    t.classList.toggle("arbo-tooltip-text-truncated", a), e = a;
  } else
    e = !0;
  return e;
}, n = {
  // Called before the bound element's attributes or event listeners are applied
  created(t, e, o) {
    t.classList.add("arbo-tooltip-wrapper"), !(!e.value || !e.value.content) && (c(t) || e.value.bypassOverflowCheck == !0 ? t._tooltipInstance = l(t, {
      content: e.value.content,
      placement: e.value.placement,
      trigger: e.value.trigger,
      hideOnClick: e.value.hideOnClick,
      delay: e.value.delay,
      theme: e.value.theme || "arbo",
      arrow: !0,
      allowHTML: !0,
      appendTo: () => document.body,
      zIndex: 9999
    }) : (t?._tooltipInstance?.destroy(), t._tooltipInstance = void 0));
  },
  // Called after the parent component and all of its children have updated
  updated(t, e, o, a) {
    c(t) || e.value.bypassOverflowCheck === !0 ? e.value !== e.oldValue && e.value.content && (t._tooltipInstance ? t._tooltipInstance.setProps({
      content: e.value.content,
      placement: e.value.placement,
      trigger: e.value.trigger,
      hideOnClick: e.value.hideOnClick,
      delay: e.value.delay,
      theme: e.value.theme || "arbo"
    }) : t._tooltipInstance = l(t, {
      content: e.value.content,
      placement: e.value.placement,
      trigger: e.value.trigger,
      hideOnClick: e.value.hideOnClick,
      delay: e.value.delay,
      theme: e.value.theme || "arbo",
      arrow: !0,
      allowHTML: !0,
      appendTo: () => document.body,
      zIndex: 9999
    })) : (t?._tooltipInstance?.destroy(), t._tooltipInstance = void 0);
  },
  // Called before the parent component is unmounted
  beforeUnmount(t, e, o) {
    t._tooltipInstance && (t._tooltipInstance.destroy(), delete t._tooltipInstance);
  },
  // Called when the parent component is unmounted
  unmounted(t, e, o) {
    t._tooltipInstance && (t._tooltipInstance.destroy(), delete t._tooltipInstance);
  }
};
export {
  n as t
};
